const faqData = [
  {
    q: '小草影院真的完全免费吗？',
    a: '是的，小草影院全站资源完全免费，无需注册登录即可直接观看。我们承诺不向用户收取任何观影费用，也不会设置付费墙或会员门槛。您打开网站即可浏览和播放所有内容，享受流畅的高清观影体验。',
  },
  {
    q: '为什么小草影院的播放速度这么快？',
    a: '小草影院采用多线路 CDN 智能加速技术，在全国范围内部署了数百个加速节点，确保无论您身处何地都能获得最优的播放线路。同时我们优化了视频编码与加载策略，实现了不缓冲、秒开播的流畅体验。',
  },
  {
    q: '小草影院的影片资源多久更新一次？',
    a: '我们的内容团队每日更新影片库，平均每天上架 300 余部新内容，涵盖院线新片、热播剧集、经典老片、高分纪录片等多种类型。热门大片通常在上映后第一时间同步上线，确保您不错过任何精彩。',
  },
  {
    q: '手机和平板可以观看吗？需要下载 App 吗？',
    a: '小草影院已全面适配移动端设备，包括 iOS 和 Android 系统的手机与平板。您无需下载任何 App，直接在手机浏览器中打开我们的网站即可享受与电脑端完全一致的高清观影体验，支持横屏全屏播放，省内存、零广告骚扰。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问答</h2>
          <p className="text-sm text-foreground-500">关于小草影院的常见问题与解答，快速了解我们的服务。</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden" open>
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-6 h-6 hidden items-center justify-center shrink-0 text-foreground-400 group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}